/* src/app/modules/shared/components/header-column/header-column-producer/header-column-producer.component.scss */
app-header-column-producer {
  display: contents;
}
/*# sourceMappingURL=header-column-producer.component.css.map */
